import { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import type { Agent, Tool } from '@/types'
import { listAgentTools } from '@/lib/api'
import { CardGrid, Card } from '@/components/ui/Card'
import { Badge } from '@/components/ui/Badge'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

export function AgentToolsTab() {
  const { agent } = useOutletContext<{ agent: Agent }>()
  const [tools, setTools] = useState<Tool[]>([])

  useEffect(() => {
    listAgentTools(agent.id).then(setTools)
  }, [agent.id])

  return (
    <div>
      <PendingBackendNotice endpoint={`GET /agents/${agent.id}/tools`} />
      <CardGrid>
        {tools.map((tool) => (
          <Card key={tool.id}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <div style={{ fontSize: 14, fontWeight: 500 }}>{tool.name}</div>
              <Badge>{tool.tool_type}</Badge>
            </div>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8 }}>{tool.description}</p>
            <div className="mono" style={{ fontSize: 11 }}>
              {tool.id} · vive en: {tool.lives_on} · auth: {tool.auth_method}
            </div>
          </Card>
        ))}
      </CardGrid>
    </div>
  )
}
